import { render, staticRenderFns } from "./socail-assitance.vue?vue&type=template&id=00e4fd79&scoped=true"
import script from "./socail-assitance.vue?vue&type=script&lang=js"
export * from "./socail-assitance.vue?vue&type=script&lang=js"
import style0 from "./socail-assitance.vue?vue&type=style&index=0&id=00e4fd79&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e4fd79",
  null
  
)

export default component.exports